export default __webpack_public_path__ + "static/media/icon_warning.6eaf6db6.svg";